/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Header_Account_Search_PlaceholderInputs */

const de_commons_header_account_search_placeholder = /** @type {(inputs: Commons_Header_Account_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Konto suchen`)
};

/** @type {(inputs: Commons_Header_Account_Search_PlaceholderInputs) => LocalizedString} */
const en_commons_header_account_search_placeholder = de_commons_header_account_search_placeholder;

/**

* @param {Commons_Header_Account_Search_PlaceholderInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_header_account_search_placeholder = /** @type {((inputs?: Commons_Header_Account_Search_PlaceholderInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Header_Account_Search_PlaceholderInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_header_account_search_placeholder(inputs)
	return en_commons_header_account_search_placeholder(inputs)
});